import './Logo.sass'
import * as React from 'react'

import { LogoProps } from './'
import letsenhanceLogo from '../../images/logos/letsenhance-logo.svg'

const Logo: React.SFC<LogoProps> = ({ wrapperClass = '' }) => {
  return (
    <nav className={`nav-main ${wrapperClass}`}>
      <object data={letsenhanceLogo} type="image/svg+xml" />
      <span className="nav-logo-text">
        Let’s<br/>
        Enhance<br/>
        .io
      </span>
    </nav>
  )
}

export default Logo
